import { clipboardMixin } from '../../common/js/clipboard/clipboard-mixin';

export default {
	mixins: [clipboardMixin]
};
